export const wait = (time = 100) =>
  new Promise((resolve) =>
    setTimeout(() => {
      console.log(`waited for ${time}ms`)
      resolve(true)
    }, time)
  )
